import { css } from 'styled-components';

export const PaperWhiteSkin = css`
  background: #faf9f7;
  border: 5px solid #1e1e1e;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
`;

export const PaperWhiteWrapperSkin = css`
  background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
`;

export const PaperWhiteLetterSkin = css<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#1e1e1e' : '#dddddd')};
  opacity: 1;
  text-shadow: none;
`;
